module.exports = __webpack_public_path__ + "static/media/makeappointmenticon.458a6ea3.svg";